"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const react_2 = require("@osmosys/react");
const hooks_1 = require("../../../../hooks");
exports.DeleteIntegrationButton = ({ integration }) => {
    const { mutate } = hooks_1.useDeleteIntegration(integration.id);
    return (react_1.default.createElement("div", { className: "flex-full-row-centered" },
        react_1.default.createElement("div", { className: "flex-col-centered" },
            react_1.default.createElement(react_2.OsmosysButton, { osysName: "DeleteButton", mutate: mutate, osysIcon: "trash", color: "warning", confirm: true },
                "Delete ",
                integration.displayType,
                " ",
                integration.isESP && 'integration'))));
};
//# sourceMappingURL=DeleteIntegrationButton.js.map